/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import InViewComponent from '../../../shared/components/inView/inView';


const Section = props => {
    const [inViewBanner, setInViewBanner] = useState(false);

    useEffect(() => {
        handleAnimation();
    }, [inViewBanner]);

    const handleAnimation = () => {
        const textHeading = document.getElementsByClassName(props.className);

        if (textHeading) {
            if (inViewBanner) {
                for (let i = 0; i < textHeading.length; i++) {
                    setTimeout(() => {
                        textHeading[i].classList.add("is-animate");
                    }, i * 200);
                }
            } else {
                for (let i = 0; i < textHeading.length; i++) {
                    textHeading[i].classList.remove("is-animate");
                }
            }
        }
    };
    return (
        <InViewComponent className="onboard" setInview={ (value) => {
            setInViewBanner(value);
        } }>
            {props.children }
        </InViewComponent>
    );
};

export default Section;